export { Connector, default } from "./src/connector";
export type {
    ConnectorProps,
    ConnectorLogo,
    CustomerQuote
} from "./src/connector";
